/**
 * Внутренние помощники, которые используются несколькими sub-компонентами
 * ChatPanel (RoomList и ChatHeader) — чтобы не дублировать switch.
 */

import { Hash, Users, Megaphone } from 'lucide-react'

export function getRoomIcon(type) {
    switch (type) {
        case 'channel': return Hash
        case 'group': return Users
        case 'announcement': return Megaphone
        default: return null
    }
}
